var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner",class:_vm.className},[_c('h1',{staticClass:"banner-title",domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('div',{staticClass:"banner-desc",domProps:{"innerHTML":_vm._s(_vm.desc)}}),_c('router-link',{staticClass:"banner-link",attrs:{"to":"/try"}},[_vm._v("申请使用")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }